<button
    mat-icon-button
    type="button"
    [class.validate]="mapFilterCompositionService.isCompositionCheckedAndValid() === null"
    [disabled]="mapFilterCompositionService.isValidationInProgress()"
    [matTooltip]="'mapFilter.validateFilterComposition' | transloco"
    (click)="mapFilterCompositionService.checkComposition()">
    @if (mapFilterCompositionService.isValidationInProgress()) {
        <app-loading
            [hasMessage]="false"
            [size]="14"
            [strokeWidth]="1" />
    } @else if (mapFilterCompositionService.isCompositionCheckedAndValid() === null) {
        <p>{{ 'validate' | transloco }}</p>
    } @else {
        <fa-icon
            class="icon-button"
            [class]="mapFilterCompositionService.isCompositionCheckedAndValid() ? 'text-custom-green' : 'text-error'"
            [icon]="['fas', 'circle-check']" />
    }
</button>
